module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAGFBMVEUAAAA0PkYzZmYzPEUyPEU1PkZAQIAyPESeWWnSAAAAB3RSTlMAgAWurVcEDbfefwAAANVJREFUeF7tzjEKwlAQRVETsLezDWQHaewtrF2CWwgR3vZlMHARJrypZV4xv7qcf3Lr9XqS9P9BBx100MF5OgrGZxpcl6NgXrNg0DblwXjTJQOkJQ9mac0AfQkCAEEASNL9JwAIIg3eE4EA0mDQThAA8KWUIDgGIAgMAEGQADlBAGCICBwAQQDgiAgcAEEA4Ih4LQCxBwCeiAegQMQF8MQrLoAnHnEACkQcAEMwAEMwAE8A1AkATwDUCQBPANQJgDoB4AmAIgFQJQCKBECVACgSHuj1eh/z+/GGKQm+6gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/down.png
// module id = arZY
// module chunks = 0